<template>
  <!-- eslint-disable -->
<svg class="better-life-efficiency-crv crv-svg-icon"  xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
    <path d="M17.9956735,3 L18,19 L13.8379002,19 L13.8379002,7.21075741 L17.9956735,3 Z M12.5659071,8.50603732 L12.5659071,19 L8.40380733,19 L8.40380733,12.7036224 L12.5659071,8.50603732 Z M7.15777329,13.9681668 L7.1620998,19 L3,19 L3,18.2228321 L7.15777329,13.9681668 Z"/>
</svg>
<!-- eslint-enable -->
</template>